export enum IEntitiesTypes {
  GET_COUNTRIES_LIST_START = 'GET_COUNTRIES_LIST_START',
  GET_COUNTRIES_LIST_FAILED = 'GET_COUNTRIES_LIST_FAILED',
  GET_COUNTRIES_LIST_SUCCESS = 'GET_COUNTRIES_LIST_SUCCESS',
}
